import { USERGROUPS_HAS_ERROR, USERGROUPS_IS_LOADING, USERGROUPS_FETCH_DATA_SUCCESS, USERGROUPS_CREATE_CACHE} from '../actions/usergroups'

   
export function usergroupsHasError(state = null, action) {
    switch (action.type) {
        case USERGROUPS_HAS_ERROR:
            return action.error;

        default:
            return state;
    }
}

export function usergroupsIsLoading(state = false, action) {
    switch (action.type) {
        case USERGROUPS_IS_LOADING:
            return action.isLoading;

        default:
            return state;
    }
}

export function usergroups(state = [], action) {
    switch (action.type) {
        case USERGROUPS_FETCH_DATA_SUCCESS:
            return action.groups;
   
        default:
            return state;
    }
}

export function usergroupsCache(state = [], action) {
    switch (action.type) {
        case USERGROUPS_CREATE_CACHE:
            return action.groupsCache;
          
        default:
            return state;
    }
}